import { Banknote, Heart } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { CompensationType } from '@/shared/model/enums';

import { Badge } from './Badge';

/**
 * Shows how a coverage slot is compensated: a green Heart "تطوّع" or a gold
 * Banknote "مدفوع — يُتفق عليه خارج التطبيق". Icon + label carry the meaning
 * (never color alone). Badeel processes no payments — paid means the parties
 * settle terms outside the app.
 */
export function CompensationBadge({ value }: { value: CompensationType }): JSX.Element {
  const { t } = useTranslation();
  if (value === 'paid_offline') {
    return (
      <Badge
        label={t('coverage.compPaidOffline')}
        color="var(--color-accent-text)"
        icon={<Banknote />}
      />
    );
  }
  return (
    <Badge label={t('coverage.compVolunteer')} color="var(--color-primary)" icon={<Heart />} />
  );
}
